import ColorPickerModal from "./ColorPickerModal";

export default ColorPickerModal;
